<div class="account-section">
  <div class="my-section-box">
    <form [formGroup]="vehicleInformationForm">
      <div class="my-section-box__headline">{{'dataExtractionRquest.vehicleInformation'|cxTranslate}}
      </div>
      <div class="data-extraction__form">
        <div class="my-section-box-inner">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleIdentificationNumber"
                class="control-label">{{'vehicleInformation.vehicleIdentificationNumber'|cxTranslate}}</label>
              <input type="text" class="form-control" formControlName="vehicleIdentificationNumber"
                [ngClass]="{ 'is-valid':(vehicleInformationForm?.get('vehicleIdentificationNumber')?.dirty || submitted) && !vehicleInformationForm?.get('vehicleIdentificationNumber')?.errors, 
                                            'is-invalid': (vehicleInformationForm?.get('vehicleIdentificationNumber').dirty|| submitted) && vehicleInformationForm?.get('vehicleIdentificationNumber')?.errors }" />
              <div class="invalid-feedback">
                @if ( vehicleInformationForm?.get('vehicleIdentificationNumber')?.errors &&
                vehicleInformationForm?.get('vehicleIdentificationNumber')?.errors['required']) {
                <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                }
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleYear" class="control-label">{{'vehicleInformation.vehicleYear'|cxTranslate}}</label>
              <input type="text" formControlName="vehicleYear" class="form-control" name="vehicleYear"
                [ngClass]="{ 'is-valid': (vehicleInformationForm?.get('vehicleYear').dirty || submitted) && !vehicleInformationForm?.get('vehicleYear')?.errors, 
                                                                'is-invalid': (vehicleInformationForm?.get('vehicleYear').dirty || submitted) && vehicleInformationForm?.get('vehicleYear')?.errors }">
              <div class="invalid-feedback">
                @if ( vehicleInformationForm?.get('vehicleYear')?.errors &&
                vehicleInformationForm?.get('vehicleYear')?.errors['required']) {
                <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                }
              </div>
            </div>
          </div>

          <div class="row margin-top-25">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleMake" class="control-label">{{'vehicleInformation.vehicleMake'|cxTranslate}}</label>
              <div class="select-box">
                <select formControlName="vehicleMake" name="vehicleMake" class="form-control" id="vehicleMake"
                  [ngClass]="{'is-valid':(vehicleInformationForm?.get('vehicleMake')?.dirty || submitted) && !vehicleInformationForm?.get('vehicleMake')?.errors,
                         'is-invalid':(vehicleInformationForm?.get('vehicleMake')?.dirty || submitted) && vehicleInformationForm?.get('vehicleMake')?.errors}">
                  <option value="null" disabled selected>
                    {{'vehicleInformation.vehicleMake'|cxTranslate}}</option>
                  @for (make of vehicleMakes; track make) {
                  <option [value]="make.code">
                    {{make.name}}</option>
                  }
                </select>
                <div class="invalid-feedback">
                  @if ( vehicleInformationForm?.get('vehicleMake')?.errors &&
                  vehicleInformationForm?.get('vehicleMake')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleModel" class="control-label">{{'vehicleInformation.vehicleModel'|cxTranslate}}</label>
              <div class="select-box">
                <select type="text" formControlName="vehicleModel" class="form-control" name="vehicleModel"
                  [ngClass]="{ 'is-valid': (vehicleInformationForm?.get('vehicleModel')?.dirty || submitted) && !vehicleInformationForm?.get('vehicleModel')?.errors,
                                 'is-invalid': (vehicleInformationForm?.get('vehicleModel')?.dirty || submitted) && vehicleInformationForm?.get('vehicleModel')?.errors }">
                  <option value="null" disabled selected>
                    {{'vehicleInformation.vehicleModel'|cxTranslate}}</option>
                  @for (model of vehicleModels; track model) {
                  <option [value]="model.code">
                    {{model.name}}</option>
                  }
                </select>
                <div class="invalid-feedback">
                  @if ( vehicleInformationForm?.get('vehicleModel')?.errors &&
                  vehicleInformationForm?.get('vehicleModel')?.errors['required']) {
                  <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                  }
                </div>
              </div>
            </div>
          </div>

          <div class="row margin-top-25">
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleTruckNumber"
                class="control-label">{{'vehicleInformation.vehicleTruckNumber'|cxTranslate}}</label>
              <input type="text" formControlName="vehicleTruckNumber" class="form-control" name="vehicleTruckNumber"
                [ngClass]="{ 'is-valid': (vehicleInformationForm?.get('vehicleTruckNumber')?.dirty || submitted) && !vehicleInformationForm?.get('vehicleTruckNumber')?.errors, 'is-invalid': (vehicleInformationForm?.get('vehicleTruckNumber')?.dirty || submitted) && vehicleInformationForm?.get('vehicleTruckNumber')?.errors }">
              <div class="invalid-feedback">
                @if ( vehicleInformationForm?.get('vehicleTruckNumber')?.errors &&
                vehicleInformationForm?.get('vehicleTruckNumber')?.errors['required']) {
                <span class="text-danger-show">{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                }
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
              <label for="vehicleMileage"
                class="control-label">{{'vehicleInformation.vehicleMileage'|cxTranslate}}</label>
              <div class="d-flex align-items-center">
                <input type="text" formControlName="vehicleMileage" class="form-control" name="vehicleMileage">
                <label for="vehicleMileage"
                  class="control-label width-70 miles-label">&nbsp;&nbsp;{{'vehicleInformation.mileageUnit'|cxTranslate}}</label>
              </div>
            </div>
          </div>

          <div class="endsure-btnblock">
            <button class="btn-action btn-back mt-4" (click)="back()">
              <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
              {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

            <button class="btn-action btn-next mt-4" [disabled]="!vehicleInformationForm.valid"
              (click)="next()">{{'dataExtractionRquest.Next'|cxTranslate}}
              <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
            </button>

          </div>
        </div>
      </div>
    </form>
  </div>
</div>